import { apiClient } from './api';

export interface GeocodingResult {
  displayName: string;
  fullAddress: string;
  city: string;
  district: string;
  latitude: number;
  longitude: number;
  country?: string;
  postalCode?: string;
}

interface SearchAddressesResponse {
  success: boolean;
  data: GeocodingResult[];
}

interface ReverseGeocodeResponse {
  success: boolean;
  data?: GeocodingResult;
  error?: {
    code: string;
    message: string;
  };
}

export const geocodingService = {
  async searchAddresses(query: string): Promise<GeocodingResult[]> {
    if (!query || query.trim().length < 3) {
      return [];
    }

    try {
      const response = await apiClient.post<SearchAddressesResponse>('/geo/geocoding/search', {
        query: query.trim(),
      });

      const payload = response.data as { success?: boolean; data?: GeocodingResult[] };
      return Array.isArray(payload.data) ? payload.data : [];
    } catch (error: any) {
      console.error('Address search error:', error);
      
      if (error?.response?.status === 500) {
        const errorMessage = error?.response?.data?.error?.message || '';
        if (errorMessage.includes('API key not configured') || errorMessage.includes('access token not configured')) {
          console.warn('Geocoding service not configured. Please add API keys to .env file.');
        }
      }
      
      return [];
    }
  },

  async reverseGeocode(latitude: number, longitude: number): Promise<GeocodingResult | null> {
    try {
      const response = await apiClient.post<ReverseGeocodeResponse>('/geo/geocoding/reverse', {
        latitude,
        longitude,
      });

      const payload = response.data as { success?: boolean; data?: GeocodingResult };
      if (!payload.success || !payload.data) {
        return null;
      }

      return payload.data;
    } catch (error) {
      console.error('Reverse geocoding error:', error);
      return null;
    }
  },
};
